module.exports = __webpack_public_path__ + "static/media/gold_rush.pragmaticplay.270be268.jpeg";